import React, { useEffect, useState } from "react";
import { Table, Button, Row, Col,Tooltip, Drawer, Grid } from "antd";
import { DeleteOutlined, EditOutlined, PlusOutlined ,  QuestionCircleOutlined} from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { fetchOriginsList, deleteOrigin } from "../originsThunks";
import { App } from "antd";
import { selectOriginsList } from "../originsSelectors";
import { setSelectedOrigin, setIsEditOrigin } from "../originsSlice";
import { getAccessType } from "../../../lib/functions";
import { useIsAdminUser } from "../../../lib/accessList";

const OriginsList = () => {
  const { modal } = App.useApp();
  const { useBreakpoint } = Grid;
  const screens = useBreakpoint();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const isAdminUser = useIsAdminUser();
   const authInfo = useSelector((state) => state.auth?.auth_info);

  const canEdit = authInfo?.can_edit === 1;
  const canDelete = authInfo?.can_delete === 1;


  const originsList = useSelector(selectOriginsList);
  let [access_type, access_type_set] = useState("");
  const [helpOpen, setHelpOpen] = useState(false);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
  });


  const handleTableChange = (pagination) => {
    setPagination(pagination);
  };
  useEffect(() => {
    const access = getAccessType("origin_manage");
    access_type_set(access);
  }, []);

  const handleDelete = (origin_id, origin_name) => {
    modal.confirm({
      title: "Are you sure?",
      content: `This will delete origin: ${origin_name}`,
      okText: "Yes, Delete",
      cancelText: "Cancel",
      onOk: async () => {
        try {
          await dispatch(deleteOrigin(origin_id)).unwrap();
          modal.success({ title: "Origin deleted successfully" });
          dispatch(fetchOriginsList());
        } catch (err) {
          modal.error({ title: err.message || "Delete failed" });
        }
      },
    });
  };

  const columns = [
    { title: "No.", render: (_, __, index) => index + 1 },
    { title: "Origin Name", dataIndex: "origin_name" },
    ...(access_type === "WRITE"
      ? [
          {
            title: "Actions",
            render: (_, record) => (
              <>
                <Button
                  type="link"
                  disabled={!(isAdminUser || canEdit)}
                  onClick={() => {
                    dispatch(setSelectedOrigin(record));
                    dispatch(setIsEditOrigin(true));
                    navigate("addNewOrigin");
                  }}
                  icon={<EditOutlined />}
                />
                <Button
                  type="link"
               disabled={!(isAdminUser || canDelete)}
                  danger
                  onClick={() =>
                    handleDelete(record.origin_id, record.origin_name)
                  }
                  icon={<DeleteOutlined />}
                />
              </>
            ),
          },
        ]
      : []),
  ];

  useEffect(() => {
    dispatch(setSelectedOrigin(null));
    dispatch(setIsEditOrigin(false));
    dispatch(fetchOriginsList());
  }, [dispatch]);

  return (
    <>
      <Row justify="end" style={{ marginBottom: "32px", marginTop: "32px" }}>
      <Col>
          <Tooltip title="Help">
            <Button
              type="text"
              icon={<QuestionCircleOutlined style={{ fontSize: 18 }} />}
              onClick={() => setHelpOpen(true)}
            />
          </Tooltip>
        </Col>
        <Col>
          {access_type == "WRITE" && (
            <>
              <Button
                type="primary"
                className="traic-button"
                icon={<PlusOutlined />}
                onClick={() => {
                  dispatch(setSelectedOrigin(null));
                  dispatch(setIsEditOrigin(false));
                  navigate("/inventory/origins-manage/addNewOrigin");
                }}
              >
                Add New
              </Button>
            </>
          )}
        </Col>
      </Row>
      <Table
        columns={columns}
        dataSource={originsList}
        rowKey="origin_id"
        pagination={{
          ...pagination,
          showSizeChanger: true,
          pageSizeOptions: ["10", "20", "50"],
        }}
        onChange={handleTableChange}
        scroll={{ x: "max-content" }}
      />
      <Drawer
        title="Origin Management Help"
        open={helpOpen}
        onClose={() => setHelpOpen(false)}
        width={420}
        styles={{
          wrapper: {
            paddingTop: !screens.md ? "80px" : undefined
          }
        }}
      >
        <div style={{ lineHeight: 1.8 }}>
          <h2
            style={{
              fontSize: "18px",
              fontWeight: 600,
              marginBottom: "12px",
              marginLeft: "8px",
            }}
          >
            Item Origin Management
          </h2>

          <p
            style={{
              color: "#555",
              marginBottom: "16px",
              marginLeft: "8px",
            }}
          >
            The Item Origin module is used to create and manage product origin
            details within the ERP system. Origins help identify product source,
            classification, and inventory tracking information for reporting
            and operational purposes.
          </p>

          <div
            style={{
              background: "#f5f5f5",
              padding: "14px",
              borderRadius: "8px",
              marginBottom: "16px",
            }}
          >
            <strong>Available Actions</strong>

            <ol style={{ paddingLeft: "20px", marginTop: "10px" }}>
              <li>View existing item origins</li>
              <li>Use <strong>Add New</strong> to create origins</li>
              <li>Edit origin details when required</li>
              <li>Delete unused origins if permitted</li>
              <li>Manage product source and classification details</li>
              <li>Organize inventory reporting using origin information</li>
            </ol>
          </div>

          <div
            style={{
              background: "#fafafa",
              border: "1px solid #eee",
              padding: "14px",
              borderRadius: "8px",
            }}
          >
            <strong>Important Notes</strong>

            <ul
              style={{
                paddingLeft: "18px",
                marginTop: "10px",
                color: "#666",
              }}
            >
              <li>Origin names should remain unique.</li>
              <li>Deleting origins may affect linked inventory items.</li>
              <li>Access permissions control edit and delete actions.</li>
              <li>Origin details improve inventory organization and reporting.</li>
            </ul>
          </div>
        </div>
      </Drawer>
    </>
  );
};

export default OriginsList;
